export abstract class MlkemKeysService {
  abstract registerMlkemKeys(
    id: string,
    data: { encapsKey: string; decapsKey: string },
    registrationToken?: string
  ): Promise<void>;
  abstract updateMlkemKeys(
    id: string,
    data: { encapsKey: string; decapsKey: string },
    token?: string
  ): Promise<void>;
}
